import { oc } from '@orpc/contract';
import { z } from 'zod';
import { CatalogImage, FieldValues } from './catalog.js';
import { Id, OkResponse, Timestamp } from './common.js';
import { Code } from './meta.js';
/** Ссылка «только чтение» на коллекцию (docs/PLAN.md, разделы 2 п. 11 и 10). */
export const CollectionShare = z.object({
    id: Id,
    collectionId: Id,
    includeChildren: z.boolean(),
    expiresAt: Timestamp.nullable(),
    revokedAt: Timestamp.nullable(),
    createdAt: Timestamp,
});
const notFound = { NOT_FOUND: { status: 404, message: 'not_found' } };
export const sharesContract = {
    list: oc
        .route({ method: 'GET', path: '/collections/{collectionId}/shares' })
        .errors(notFound)
        .input(z.object({ collectionId: Id }))
        .output(z.array(CollectionShare)),
    /** Токен возвращается один раз — в БД хранится только его хеш. */
    create: oc
        .route({ method: 'POST', path: '/collections/{collectionId}/shares' })
        .errors(notFound)
        .input(z.object({
        collectionId: Id,
        includeChildren: z.boolean().default(true),
        expiresAt: Timestamp.nullable().optional(),
    }))
        .output(z.object({ share: CollectionShare, url: z.string() })),
    revoke: oc
        .route({ method: 'DELETE', path: '/shares/{id}' })
        .errors(notFound)
        .input(z.object({ id: Id }))
        .output(OkResponse),
};
export const SharedNode = z.object({
    id: Id,
    parentId: Id.nullable(),
    name: z.string(),
    count: z.number().int(),
});
export const SharedCollection = z.object({
    name: z.string(),
    description: z.string().nullable(),
    ownerName: z.string(),
    rootId: Id,
    /** Корень ссылки и (если разрешено) вложенные коллекции. */
    tree: z.array(SharedNode),
});
export const SharedSpecimenListItem = z.object({
    id: Id,
    typeCode: Code,
    title: z.string(),
    /** Итоговые значения: каталожные поля без текстов Numista и белый список полей экземпляра. */
    values: FieldValues,
    thumb: z.string().nullable(),
});
/** Фото по ссылке — без id файла (он раскрывал бы общий для владельца media). */
export const SharedImage = CatalogImage.omit({ mediaId: true });
export const SharedSpecimen = SharedSpecimenListItem.omit({ thumb: true }).extend({
    collectionId: Id,
    images: z.array(SharedImage),
});
/** Просмотр по ссылке — без входа; недействительная, отозванная или просроченная ссылка — 404. */
export const publicShareContract = {
    get: oc
        .route({ method: 'GET', path: '/public/shares/{token}' })
        .errors(notFound)
        .input(z.object({ token: z.string().min(20).max(100) }))
        .output(SharedCollection),
    specimens: oc
        .route({ method: 'GET', path: '/public/shares/{token}/specimens' })
        .errors(notFound)
        .input(z.object({
        token: z.string().min(20).max(100),
        collectionId: Id.optional(),
        q: z.string().trim().max(200).optional(),
        cursor: z.string().max(100).optional(),
    }))
        .output(z.object({ items: z.array(SharedSpecimenListItem), nextCursor: z.string().nullable() })),
    specimen: oc
        .route({ method: 'GET', path: '/public/shares/{token}/specimens/{id}' })
        .errors(notFound)
        .input(z.object({ token: z.string().min(20).max(100), id: Id }))
        .output(SharedSpecimen),
};
//# sourceMappingURL=shares.js.map